// @flow
import ua from 'universal-analytics';

// Universal Analytics
const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

const visitor = GOOGLE_ANALYTICS_ID
  ? ua(GOOGLE_ANALYTICS_ID, {
      hostname: 'https://ssl.google-analytics.com',
    })
  : null;

export function universalAnalytics(handler: (ua) => void) {
  if (visitor == null) {
    return;
  }

  handler(visitor);
}

export default universalAnalytics;



// WEBPACK FOOTER //
// ./src/common/utils/universalAnalytics.js